__turbopack_context__.v({
  "slots": "UwLNra_slots",
});
